import { render, staticRenderFns } from "./payFeeOrderResult.vue?vue&type=template&id=315f550f&scoped=true"
import script from "./payFeeOrderResult.vue?vue&type=script&lang=js"
export * from "./payFeeOrderResult.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderResult.vue?vue&type=style&index=0&id=315f550f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f550f",
  null
  
)

export default component.exports